import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  code: Yup.string()
    .required()
    .length(6),
  password: Yup.string().required(),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), ''])
    .required(),
});
